import React, { useState, useEffect, useCallback } from 'react';
import Body from '../static/Body';
import Card from '../static/Card';
import { motion } from 'framer-motion';
import Text from '../elements/TextComponent';
import { BotAnalyticsData } from '../../api/types';
import { getBotAnalyticsList } from '../../api/assistantsApi';
import BotListLoading from '../static/BotListLoading';
import BotListError from '../static/BotListError';
import BotAnalyticsCarousel from '../static/BotAnalyticsCarousel';

const useFetchBotAnalyticsList = () => {
  const [bots, setBots] = useState<BotAnalyticsData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchBots = useCallback(async () => {
    setLoading(true);
    const res = await getBotAnalyticsList(); // your updated API call
    if (res.error) {
      setError(res.error);
    } else {
      setBots(res.data || []);
      setError(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchBots();
  }, [fetchBots]);

  return { bots, loading, error, refresh: fetchBots };
};


interface Props {
  defaultStartinBotId?: string
}

const Analytics: React.FC<Props> = ({defaultStartinBotId}) => {
  const botId = defaultStartinBotId ?? undefined;

  const { bots, loading, error } = useFetchBotAnalyticsList();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.3 }}
    >
      <Body>
        <Card width="92%">
          <Text
            text="Analytics"
            fontSize="26px"
            fontWeight="700"
            lineHeight="28px"
            color="#030303"
            textAlign="left"
          />
          <div className="margin-top-10" />
          <Text
            text="View your assistants analytics"
            fontSize="16px"
            fontWeight="400"
            lineHeight="28px"
            color="#030303"
            textAlign="left"
          />
        </Card>

        <Card height="600px" width="92%">
          {loading ? (
            <BotListLoading />
          ) : error ? (
            <BotListError message={error} />
          ) : (
            <BotAnalyticsCarousel bots={bots} defaultBotId={botId} />
          )}
        </Card>
      </Body>
    </motion.div>
  );
};


export default Analytics